import requests from "./httpService";

const ActivityLogService = {
    getLogs(companyId, page = 1, limit = 20, searchTerm = '', startDate = '', endDate = '') {
        return requests.get(`/activity-logs/all?company_id=${companyId}&page=${page}&limit=${limit}&searchTerm=${searchTerm}&startDate=${startDate}&endDate=${endDate}`);
    },
};

export default ActivityLogService;
